import React from 'react'

const ModalHeader = ({
    children,
}) => {

    return (
        <div
            style={{
                backgroundColor: 'rgb(0, 105, 217)',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <div style={{ color: 'white', fontSize: '1.2em', padding: '20px' }}>
                <strong>{children}</strong>
            </div>
        </div>
    )
}

export default ModalHeader
